import { Component, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { Router } from '@angular/router';
import { filter } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard-cctv',
  templateUrl: './dashboard-cctv.component.html',
  styleUrls: ['./dashboard-cctv.component.scss']
})
export class DashboardCctvComponent implements OnInit {
  cctvcameraconnected: any = []
  selected_value: any;
  show: boolean = true;
  id: any;
  filterBy: any;
  cctvcameraconnec: any;
  searchkey: string = '';
  public searchTerm: string = '';
  hide: boolean = false;
  object = {}
  vijay: any = [];

  constructor(public campuscctvserviceservice: CampuscctvserviceService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    // localStorage.clear();
    this.dashconnected();


  }
  dashconnected() {
    this.spinner.show();
    this.selected_value = "STATE"
    this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
      // localStorage.setItem('stateId', res.id);
      this.cctvcameraconnected = res;
      console.log('STATE', this.cctvcameraconnected);
      this.spinner.hide();
    });
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } });

  }

  onOptionsSelected(e: any) {
    this.show = true;
    this.spinner.show();
    this.selected_value = e.target.value;
    if (this.selected_value === "STATE") {
      this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
        // localStorage.setItem('stateId', res.id);
        this.cctvcameraconnected = res;
        this.hide = false;
        console.log("state", this.cctvcameraconnected);
        this.filterBy=this.cctvcameraconnected.filterBy;
        this.id =this.cctvcameraconnected.id;
        console.log('filter',this.filterBy,'id',this.id);
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    } else if (this.selected_value === "CITY") {
      this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
        // localStorage.setItem('cityId', res.id);
        this.cctvcameraconnected = res;
        // localStorage.setItem('cityId', this.cctvcameraconnected.id);
        this.hide = false;
        console.log('city', this.cctvcameraconnected);
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    } else if (this.selected_value === "CAMPUS") {
      this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
        // localStorage.setItem('campusId', res.id);
        this.cctvcameraconnected = res;
        this.hide = false;
        console.log('campus', this.cctvcameraconnected);
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigaterighttochange(data: any) {
    console.log('response', data);
    this.filterBy = data.filterBy
    this.id = data.id
    console.log('filterby :', this.filterBy, 'id :', this.id);
    this.spinner.show()
    this.hide = true;
    if (this.filterBy === "STATE") {
      localStorage.setItem('stateId', data.id);
      this.campuscctvserviceservice.getconnectedstateright(this.filterBy, this.id).subscribe((res) => {
        this.cctvcameraconnected = res;
        console.log('city Resp:', this.cctvcameraconnected)

        this.spinner.hide()
      })
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    } else if (this.filterBy === "CITY") {
      localStorage.setItem('cityId', data.id);
      this.campuscctvserviceservice.getconnectedstateright(this.filterBy, this.id).subscribe((res) => {
        this.cctvcameraconnected = res;
        console.log('campus :', this.cctvcameraconnected);
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });

    }
    else if (this.filterBy === "CAMPUS") {
      localStorage.setItem('campusId', data.id);
      console.log('id :', this.id);
      this.show = false;
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigateBackward(data: any) {
    const filterBy = data.filterBy
    const id = data.id;
    if (filterBy == 'CAMPUS' && this.show == false) {
      this.spinner.show();
      this.campuscctvserviceservice.getconnectedstateright("CITY", localStorage.getItem('cityId')).subscribe((res) => {
        this.cctvcameraconnected = res;
        this.spinner.hide();
        this.show = true;
        console.log(res);
      });
      
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
      if (this.selected_value === "CAMPUS") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
          this.cctvcameraconnected = res;
          this.spinner.hide();
        });
      }

    } else if (filterBy == 'CAMPUS' && this.show == true) {
      if (localStorage.getItem('stateId')) {
        
        this.campuscctvserviceservice.getconnectedstateright("STATE", localStorage.getItem('stateId')).subscribe((res) => {
          this.cctvcameraconnected = res;

          console.log(res);
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      else {
      
        this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
          // localStorage.setItem('stateId', res.id);
          this.cctvcameraconnected = res;
          console.log(this.cctvcameraconnected);
        
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      if (this.selected_value === "CITY") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvcamera(this.selected_value).subscribe((res) => {
          this.cctvcameraconnected = res;
          this.spinner.hide();
        });
       
      }
    }
    else if (filterBy == "CITY") {
      this.hide = false;
      this.dashconnected();
    }
  }

  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
  }
}


